import Lists from './lists'

export default Lists;